import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import { AuthModule, AuthModuleState } from "./AuthModule";

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ["auth"]
});

export interface RootState {
  auth: AuthModuleState;
}

export const store = new Vuex.Store<RootState>({
  actions: {
    reset: ({ commit }) => {
      commit("auth/reset");
    }
  },
  modules: { auth: AuthModule },
  plugins: [vuexLocal.plugin]
});
